export default {
  // market
  tabNews: "News",
  tabJobPostings: "Job postings",
  expansions: "Expansion Signals",
  marketSort: "Sort",
  marketFilter: "Filter",
  marketReset: "Reset",
  marketFilterGalleries: "Galleries",
  marketFilterCategories: "Categories",
  recent: "Recent",
  earlier: "Earlier",
  minuteAgo: "{count} minute ago | {count} minutes ago",
  hourAgo: "{count} hour ago | {count} hours ago",
  dayAgo: "{count} day ago | {count} days ago",
  weekAgo: "{count} week ago | {count} weeks ago",
  on: "On",
  readArticle: "Read article",
  viewPosting: "View posting",
  moreNumber: "+{count} more",

  // empty content text
  noNewsArticlesFound: "No News Articles Found",
  nothingMatchSearch:
    "Looks like we couldn’t find anything matching your search. Try different keywords or check back later for the latest updates!",
  noJobListingsAvailable: "No Job Listings Available",
  noJobPostingsMatching:
    "It looks like there are no job postings matching your search. Try different keywords or come back later to explore new opportunities.",
  noAdsFound: "No Ads Found",
  noAdsFoundDesc:
    "No recent ads detected at the moment. Check back soon for the latest updates.",
  noActivitiesTrackedYet: "No Activities Tracked Yet",
  noAdsMatch: "Nothing Match Ad Search",
  noAdsMatchDesc:
    "We couldn’t find any ads that match your search. Try tweaking your keywords or check back soon for new updates.",
  noTrackedAnyActivities:
    "We haven’t tracked any activities for this company yet. Check back later for updates",
  noTechnologiesFound: "No Technologies Found",
  cantFindAnyInformationOnTheTechnologies:
    "We couldn’t find any information on the technologies this company uses. Stay tuned for updates.",

  // company info
  seeLess: "see less",
  seeMore: "see more",

  // technology
};
